/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NotificationsContainer.vue?vue&type=template&id=3b122e1c"
import script from "./NotificationsContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationsContainer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NotificationsContainer.vue?vue&type=style&index=0&id=3b122e1c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports